import { useConfiguratorStore } from '../../contexts/ConfiguratorStore'
import { useProductPageStore } from '../../contexts/ProductPageStore'
import ProductPageSuspense from '../productPageSuspense/productPageSuspense'
import AddToCartForm from './atcForm/atcForm'
import NonSaleableAddToCartForm from './atcForm/nonSaleableAtcForm'
import Bullets from './bullets/bullets'
import KitDetailsDrawerHandler from './kitDetailsDrawerHandler'
import styles from './offer.module.scss'
import Pricing from './pricing/pricing'
import ConfiguratorRatingAndQuestionsOverview from './rating/configuratorRating'
import Shipping from './shipping/shipping'
import Title from './title/title'
import VehicleFitment from './vehicleFitment/vehicleFitment'

import React, { useMemo, useState } from 'react'

import LayerColorFinder from 'Clutch/Utilities/LayerColorFinder'

import IndexOptions from 'Clutch/Components/IndexOptions'

import Button from 'Clutch/Molecules/Button'

import Divider from 'Clutch/Atoms/Divider'
import TextLink from 'Clutch/Atoms/TextLink'
import Typography from 'Clutch/Atoms/Typography'

const ConfiguratorOffer = () => {
  const skuBaseNumber = useProductPageStore((x) => x.skuBaseNumber)
  const skuVariantNumber = useProductPageStore((x) => x.skuVariantNumber)
  const isPurchaseable = useProductPageStore((x) => x.isPurchaseable)
  const bullets = useProductPageStore((x) => x.bullets)
  const indexOptions = useConfiguratorStore((x) => x.indexOptions)
  const selectIndexOption = useConfiguratorStore((x) => x.selectIndexOption)
  const isIndexOptionErrorState = useProductPageStore((x) => x.isIndexOptionErrorState)
  const availability = useProductPageStore((x) => x.availability)
  const isConfigured = useProductPageStore((x) => x.isConfigured)

  const [isWaiting, setIsWaiting] = useState(false)

  const backgroundColor = LayerColorFinder(1)

  return (
    <>
      <ProductPageSuspense>
        <KitDetailsDrawerHandler />
      </ProductPageSuspense>
      <Title />
      <ConfiguratorRatingAndQuestionsOverview />
      <Bullets bullets={bullets} />
      {indexOptions && indexOptions.length > 0 && bullets && bullets.length > 0 ? (
        <Divider key={'ix-option-divider'} className={styles.divider} />
      ) : (
        false
      )}

      <IndexOptions
        indexOptions={indexOptions}
        selectIndexOption={selectIndexOption}
        isIndexOptionErrorState={isIndexOptionErrorState}
        buttonCuttoffValue={0}
      />

      <div className={styles.calculatorLink}>
        <TextLink
          className={styles.offerLink}
          href={
            'https://www.speedwaymotors.com/the-toolbox/axle-ratio-calculator-calculate-ideal-tire-size-and-rear-gear-ratio/145816'
          }
          svg={'info'}
          svgSize={1}
          chevron={'right'}
          targetBlank
        >
          Gear Ratio Speed Calculator
        </TextLink>
      </div>

      {indexOptions && indexOptions.length > 0 ? (
        <Divider key={'ix-option-bottom'} className={styles.pdp_offer_option} />
      ) : (
        false
      )}
      <Pricing availability={availability} isPurchaseable={isPurchaseable} backgroundColor={backgroundColor} />
      <br />
      {isPurchaseable ? (
        <AddToCartForm isWaiting={isWaiting} setIsWaiting={setIsWaiting} />
      ) : (
        <NonSaleableAddToCartForm />
      )}
      {isConfigured && (
        <>
          <VehicleFitment />
          <Shipping
            skuVariant={skuVariantNumber}
            availability={availability}
            backgroundColor={backgroundColor}
            isPurchaseable={isPurchaseable}
          />
        </>
      )}
    </>
  )
}

export default ConfiguratorOffer
